import { render, staticRenderFns } from "./MapNavigationTypes.vue?vue&type=template&id=2549cc01&"
import script from "./MapNavigationTypes.vue?vue&type=script&lang=js&"
export * from "./MapNavigationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapNavigationType: require('/srv/rir-platform/tourism/src/tourism-front/components/common/MapNavigation/MapNavigationType.vue').default,MapNavigationPlacesType: require('/srv/rir-platform/tourism/src/tourism-front/components/common/MapNavigation/MapNavigationPlacesType.vue').default})
